import axios from "../axiosInstance";
import { handleApiResponse } from "../utils";

export const fetchUserSettings = () => handleApiResponse(() => axios.get("/general/users/settings"), null);

export const updateUserSettings = requestBody => handleApiResponse(() => axios.patch("/general/users/settings", requestBody));
